<div class="modal-container" [@openClose]="isOpen ? 'open' : 'closed'">
  <div class="unh-modal">
    <div class="unh-modal-body">
      <ng-content></ng-content>
    </div>
  </div>
  <div class="unh-modal-background"></div>
</div>
